import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postAppointment } from "@/http/clubsApi";
import { getAppointmentsQueryKey, getSlotsQueryKey } from "@/utils/queryKeys";

interface PostAppointmentData {
  date_time: string;
  service_id: string;
  employee_id: string;
  room_id: string;
  club_id: string;
  user_token: string;
}

export const usePostAppointmentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: PostAppointmentData) => {
      const response = await postAppointment(
        data.date_time,
        data.service_id,
        data.employee_id,
        data.room_id,
        data.club_id,
        data.user_token
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getAppointmentsQueryKey() });
      queryClient.invalidateQueries({ queryKey: getSlotsQueryKey() });
    },
  });
};
